import React from "react";
import InitialPropsContext from "../lib/models/initialPropsContext";
import PageNotFoundError from "../lib/pageNotFoundError";
import AdvancedArticlePage from "../components/article/AdvancedArticlePage";
import PageProps from "../lib/models/pageProps";
import { ApiResult } from "../lib/CmsApi";

type InitialResult = ApiResult<"loadGenericPageBySlug"> & {
  url: string;
};

export default function Page(props: InitialResult) {
  return (
    <AdvancedArticlePage
      {...props}
      hideBookmark
      breadCrumpPath={[
        {
          route: "genericPage",
          title: props.name,
          params: { slug: props.slug }
        }
      ]}
    />
  );
}

Page.getInitialProps = async ({
  api,
  query,
  asPath
}: InitialPropsContext): PageProps<InitialResult> => {
  const { slug } = query;
  const content = await api.loadGenericPageBySlug(slug as string).catch(() => {
    throw new PageNotFoundError();
  });

  const pageProps = {
    ...content,
    url: asPath
  };
  let _pageImages;
  try {
    _pageImages = AdvancedArticlePage.getImages(pageProps);
  } catch (error) {
    console.error(error);
  }
  return { ...pageProps, _pageImages };
};
